import dynamic from 'next/dynamic';

const ForSaleVehiclesGrid = dynamic(() =>
  import('./ForSaleVehiclesGrid/ForSaleVehiclesGrid')
);

export { ForSaleVehiclesGrid };
